{
  "pageTitle": "Տոներ",
  "holidays": {
    "title": "Ընկերության տոնական օրեր",
    "addNew": "+ Ավելացնել տոն",
    "columns": {
      "date": "Ամսաթիվ",
      "name": "Տոնի անվանում",
      "actions": "Գործողություններ"
    },
    "form": {
      "titleCreate": "Նոր տոն",
      "titleEdit": "Խմբագրել տոնը",
      "dateLabel": "Ամսաթիվ",
      "nameLabel": "Տոնի անվանում",
      "namePlaceholder": "օր․ Նոր տարի",
      "errors": {
        "dateRequired": "Ամսաթիվը պարտադիր է։",
        "nameRequired": "Տոնի անվանումը պարտադիր է։"
      }
    },
    "empty": {
      "title": "Տոներ դեռ չկան",
      "hint": "Ավելացրեք պետական կամ ընկերության հատուկ տոնական օրեր։"
    },
    "failedToLoad": "Չհաջողվեց բեռնել տոների ցուցակը։",
    "toasts": {
      "created": "Տոնը ավելացվել է։",
      "updated": "Տոնը թարմացվել է։",
      "deleted": "Տոնը հեռացվել է։",
      "saveFailed": "Չհաջողվեց պահպանել տոնը։ Կրկին փորձեք։",
      "deleteFailed": "Չհաջողվեց հեռացնել տոնը։ Կրկին փորձեք։"
    },
    "confirm": {
      "delete": "Հե՞ռացնել «{{name}}» տոնը։"
    },
    "import": {
      "button": "Ներմուծել ՀՀ տոները",
      "importing": "Ներմուծվում է…",
      "yearLabel": "Ներմուծման տարի",
      "success": "Ներմուծվել է {{imported}} տոն, բաց է թողնվել՝ {{skipped}}:",
      "failed": "Չհաջողվեց ներմուծել տոները: Խնդրում ենք կրկին փորձել:",
      "invalidYear": "Նշեք տարեթիվ 2000-ից 2100-ի սահմաններում:"
    }
  },
  "timeOff": {
    "title": "Աշխատակիցների արձակուրդներ",
    "addNew": "+ Ավելացնել արձակուրդ",
    "columns": {
      "employee": "Աշխատակից",
      "type": "Տեսակ",
      "month": "Ամիս",
      "startDate": "Սկիզբ",
      "endDate": "Ավարտ",
      "carryover": "Նախորդ տարվանից",
      "remainingDays": "Մնացած օրեր",
      "note": "Նշում",
      "actions": "Գործողություններ"
    },
    "carryoverHint": "Ներառյալ նախորդ տարվանից փոխանցված {{days}} օրը",
    "types": {
      "vacation": "Արձակուրդ",
      "sick_leave": "Հիվանդության արձակուրդ",
      "unpaid_leave": "Չվճարվող արձակուրդ",
      "business_trip": "Գործուղում",
      "day_off": "Հանգստյան օր"
    },
    "status": {
      "active": "Արձակուրդում",
      "ended": "Ավարտված",
      "upcoming": "Չի սկսվել"
    },
    "filter": {
      "label": "Զտել գրառումները",
      "yearLabel": "Տարի",
      "all": "Բոլորը",
      "emptyTitle": "Համապատասხան գրառումներ չկան",
      "emptyHint": "Ընտրված զտիչներին համապատասխան արձակուրդներ չկան։",
      "allMonths": "Բոլոր ամիսները",
      "allEmployees": "Բոլոր աշխատակիցները"
    },
    "months": {
      "1": "Հունվար",
      "2": "Փետրվար",
      "3": "Մարտ",
      "4": "Ապրիլ",
      "5": "Մայիս",
      "6": "Հունիս",
      "7": "Հուլիս",
      "8": "Օգոստոս",
      "9": "Սեպտեմբեր",
      "10": "Հոկտեմբեր",
      "11": "Նոյեմբեր",
      "12": "Դեկտեմբեր"
    },
    "form": {
      "titleCreate": "Նոր արձակուրդ",
      "titleEdit": "Խմբագրել արձակուրդը",
      "employeeLabel": "Աշխատակից",
      "employeePlaceholder": "Ընտրեք աշխատակցին",
      "typeLabel": "Տեսակ",
      "startDateLabel": "Սկզբի ամսաթիվ",
      "endDateLabel": "Ավարտի ամսաթիվ",
      "noteLabel": "Նշում (կամընտիր)",
      "notePlaceholder": "Լրացուցիչ տեղեկություններ…",
      "errors": {
        "employeeRequired": "Ընտրեք աշխատակցին։",
        "typeRequired": "Նշեք տեսակը։",
        "startDateRequired": "Նշեք սկզբի ամսաթիվը։",
        "endDateRequired": "Նշեք ավարտի ամսաթիվը։",
        "endBeforeStart": "Ավարտի ամսաթիվը չի կարող լինել սկզբի ամսաթիվից առաջ։"
      },
      "daysCount": "Ընդամենը {{count}} օր՝ ներառյալ սկզբի և ավարտի օրերը։"
    },
    "empty": {
      "title": "Արձակուրդի գրառումներ չկան",
      "hint": "Հետևեք աշխատակիցների արձակուրդներին, հիվանդության օրերին և այլ բացակայությունների։"
    },
    "failedToLoad": "Չհաջողվեց բեռնել արձակուրդի գրառումները։",
    "toasts": {
      "created": "Արձակուրդը գրանցված է։",
      "updated": "Արձակուրդը թարմացվել է։",
      "deleted": "Արձակուրդի գրառումը հեռացվել է։",
      "saveFailed": "Չհաջողվեց պահպանել արձակուրդը։ Կրկին փորձեք։",
      "deleteFailed": "Չհաջողվեց հեռացնել արձակուրդի գրառումը։ Կրկին փորձեք։"
    },
    "confirm": {
      "delete": "Հե՞ռացնել այս արձակուրդի գրառումը։"
    },
    "tabs": {
      "records": "Արձակուրդների գրառումներ",
      "calc": "Արձակուրդի հաշվարկ"
    }
  },
  "vacationCalc": {
    "title": "Արձակուրդի հաշվարկ",
    "filter": {
      "label": "Հաշվարկի տողերի զտիչ",
      "all": "Բոլորը",
      "withCarryover": "Փոխանցումով",
      "overdrawn": "Գերածախսով"
    },
    "columns": {
      "carryover": "Փոխանցում",
      "annual": "Տարեկան սահմանաչափ",
      "accrued": "Կուտակված այսօրվա դրությամբ",
      "used": "Օգտագործված",
      "unpaid": "Չվճարվող արձակուրդ",
      "availableNow": "Հասանելի հիմա",
      "remaining": "Տարեկան մնացորդ"
    },
    "empty": {
      "title": "Ցուցադրելու ոչինչ չկա",
      "hint": "Ընտրված զտիչին համապատասխանող աշխատակիցներ չկան։"
    },
    "explainer": "Յուրաքանչյուր աշխատակցին տարեկան հասնում է {{annual}} օր արձակուրդ, որը կուտակվում է աստիճանաբար՝ ({{annual}} ÷ տարվա օրերի քանակ) յուրաքանչյուր անցած օրվա համար, ուստի հունվարի վերջին կուտակված է ≈1.6 օր։ «Հասանելի հիմա» = փոխանցում + կուտակված այսօրվա դրությամբ − օգտագործված; «Տարեկան մնացորդը» հաշվարկվում է ամբողջ տարեկան սահմանաչափից։ Նախորդ տարիների փոխանցումը մուտքագրվում է աշխատակցի քարտում։ Օգտագործված են համարվում «Արձակուրդ» գրառումների միայն ԱՇԽԱՏԱՆՔԱՅԻՆ օրերը՝ ընկերության գրաֆիկով ոչ աշխատանքային օրերն ու տոները չեն հանվում, իսկ իրար հատվող գրառումները կրկնակի չեն հաշվվում։ «Չվճարվող արձակուրդ» սյունը միայն տեղեկատվական է՝ այն չի ազդում արձակուրդի հաշվեկշռի վրա։",
    "carryoverEdit": {
      "ariaLabel": "Փոխանցված օրեր",
      "saved": "Փոխանցումը պահպանվել է։",
      "saveFailed": "Չհաջողվեց պահպանել։ Կրկին փորձեք։"
    }
  },
  "aria": {
    "loading": "Բեռնում…",
    "deleteHoliday": "Հեռացնել տոնը",
    "editHoliday": "Խմբագրել տոնը",
    "deleteTimeOff": "Հեռացնել արձակուրդի գրառումը",
    "editTimeOff": "Խմբագրել արձակուրդի գրառումը"
  }
}
